import { render, staticRenderFns } from "./AuthenticateResetPassword.vue?vue&type=template&id=2ea243c0&scoped=true&"
import script from "./AuthenticateResetPassword.vue?vue&type=script&lang=js&"
export * from "./AuthenticateResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticateResetPassword.vue?vue&type=style&index=0&id=2ea243c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea243c0",
  null
  
)

export default component.exports